import React, { useEffect, useRef } from 'react';

const VideoPlayer = ({
  videoId,
  onPlayerStateChange,
  playerRef
}) => {
  const containerRef = useRef(null);

  // YouTube API 로드 (최초 1회)
  useEffect(() => {
    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      document.body.appendChild(tag);
    }
  }, []);

  // 플레이어 생성 및 videoId 변경 시 처리
  useEffect(() => {
    if (!videoId) return;

    function createPlayer(id) {
      if (!containerRef.current) return;
      if (playerRef.current) {
        playerRef.current.destroy();
      }
      playerRef.current = new window.YT.Player(containerRef.current, {
        height: '100%',
        width: '100%',
        videoId: id,
        playerVars: {
          autoplay: 0, // 초기에는 자동재생 비활성화
          controls: 1,
          modestbranding: 1,
          rel: 0,
          origin: window.location.origin,
          playsinline: 1, // iOS에서 인라인 재생
          enablejsapi: 1, // JavaScript API 활성화
          fs: 1, // 전체화면 허용
          hl: 'ko', // 한국어 설정
          iv_load_policy: 3, // 주석 비활성화
          disablekb: 0, // 키보드 컨트롤 허용
          background: 1,
          // 모바일 자동재생 관련 설정
          mute: 0, // 음소거 비활성화 (사용자가 직접 제어)
          start: 0 // 시작 시간 초기화
        },
        events: {
          onReady: (event) => {
            console.log('YouTube 플레이어 준비 완료:', event);
            // 플레이어가 준비되면 추가 설정 가능
          },
          onStateChange: (event) => {
            console.log('플레이어 상태 변경:', event.data);
            // YouTube 플레이어 상태 정의:
            // -1: 시작되지 않음
            // 0: 종료됨
            // 1: 재생 중
            // 2: 일시정지
            // 3: 버퍼링
            // 5: 동영상 큐됨
            if (onPlayerStateChange) {
              onPlayerStateChange(event);
            }
          },
          onError: (event) => {
            console.error('YouTube 플레이어 오류:', event.data);
          }
        }
      });
    }

    if (window.YT && window.YT.Player) {
      createPlayer(videoId);
    } else {
      window.onYouTubeIframeAPIReady = () => {
        createPlayer(videoId);
      };
    }

    return () => {
      if (playerRef.current) {
        try {
          playerRef.current.destroy();
        } catch (error) {
          console.error('플레이어 제거 중 오류:', error);
        }
        playerRef.current = null;
      }
    };
    // eslint-disable-next-line
  }, [videoId]);

  // videoId가 바뀔 때 cueVideoById로 미리보기만 나오게
  useEffect(() => {
    if (playerRef.current && videoId) {
      if (typeof playerRef.current.cueVideoById === 'function') {
        try {
          playerRef.current.cueVideoById(videoId);
          console.log('Video cued with ID:', videoId);
        } catch (error) {
          console.error('Video cue 중 오류:', error);
        }
      }
    }
  }, [videoId, playerRef]);

  useEffect(() => {
    console.log('videoId:', videoId);
  }, [videoId]);

  useEffect(() => {
    console.log('playerRef.current:', playerRef.current);
  }, [playerRef.current]);

  useEffect(() => {
    console.log('containerRef.current:', containerRef.current);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      console.log('window.YT:', window.YT);
      console.log('YouTube API ready:', !!window.YT?.Player);
    }, 2000);
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        width: '100%',
        height: '100%',
        background: '#000',
        position: 'relative'
      }}
    />
  );
};

export default VideoPlayer; 